export default __webpack_public_path__ + "static/media/image_icon.58662506.svg";